virtual task drive_data();
{{#with dataSequenceHandle}}
  {{> (partial "snippets/start-sequence") context=.}}
{{/with}}
endtask
